import gql from "graphql-tag";

export const CREATE_NOTE = gql`
  mutation AddNote($data: NoteDataInput) {
    addNote(data: $data) {
      id
    }
  }
`;
export const DELETE_NOTE = gql`
  mutation DeleteNote($where: NoteWhereInput) {
    deleteNote(where: $where) {
      id
    }
  }
`;
export const UPDATE_NOTE = gql`
  mutation UpdateNote($where: NoteWhereInput, $data: NoteDataInput) {
    updateNote(where: $where, data: $data) {
      id
      content
      updatedDate
    }
  }
`;

const notes = { CREATE_NOTE, DELETE_NOTE, UPDATE_NOTE };

export default notes;
